module.exports = __webpack_public_path__ + "static/media/icon-romaneio.7b9e0241.svg";